// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__RmD_I","col":"styles_col__180AQ","fulfillmentStatus":"styles_fulfillmentStatus__1U16r","emailCol":"styles_emailCol__1nCTg"};